<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list"
          >{{ this.parentRoute.menuName }}-药品基础信息维护详情</span
        >
      </div>
      <div class="cont-main">
        <el-form label-position="left" ref="form" :model="form">
          <el-row class="show-header" :gutter="30">
            <el-col :span="6">
              <el-form-item label="药品名称:" prop="name">
                <EllipsisWithTooltip :content="form.basicInfo.name || '-'" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="药品规格:" prop="specifications">
                <EllipsisWithTooltip :content="form.basicInfo.specifications || '-'" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="药品剂型:" prop="dosageFormName">
                <EllipsisWithTooltip :content="form.basicInfo.dosageFormName || '-'" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="库存单位:" prop="inventoryUnit">
                <EllipsisWithTooltip :content="form.basicInfo.inventoryUnit || '-'" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="最小单位:" prop="smallestUnit">
                <EllipsisWithTooltip :content="form.basicInfo.smallestUnit || '-'" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="库存单位换算系数:"
                prop="inveUnitConverFactor"
              >
                <EllipsisWithTooltip :content="form.basicInfo.inveUnitConverFactor || '-'" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-tabs type="card" v-model="activeName" class="demo-tabs">
            <el-tab-pane label="基础信息" name="basicInfo">
              <el-row :gutter="30" style="width: 100%;">
                <el-col :span="6">
                  <el-form-item label="药品编号:" prop="no">
                    <EllipsisWithTooltip :content="form.basicInfo.no || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="通用名:" prop="commonName">
                     <EllipsisWithTooltip :content="form.basicInfo.commonName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="拼音码:" prop="pinyinCode">
                    <EllipsisWithTooltip :content="form.basicInfo.pinyinCode || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="剂量单位:" prop="doseUnitName">
                    <EllipsisWithTooltip :content="form.basicInfo.doseUnitName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="基本剂量:" prop="basicdDose">
                     <EllipsisWithTooltip :content="form.basicInfo.basicdDose || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="药品类型:" prop="drugTypeName">
                    <EllipsisWithTooltip :content="form.basicInfo.drugTypeName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="药品分类:" prop="classificationName">
                    <EllipsisWithTooltip :content="form.basicInfo.classificationName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="财务分类:" prop="financialClass">
                    <EllipsisWithTooltip :content="form.basicInfo.financialClassName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="产地:" prop="factoryInfoName">
                    <EllipsisWithTooltip :content="form.basicInfo.factoryInfoName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="包装材质:" prop="packagingMaterial">
                     <EllipsisWithTooltip :content="form.basicInfo.packagingMaterial || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="有效期（月）:"
                    prop="termOfValidityByMon"
                  >
                    <EllipsisWithTooltip :content="form.basicInfo.termOfValidityByMon || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="条码管理:" prop="barcodeManagementName">
                     <EllipsisWithTooltip :content="form.basicInfo.barcodeManagementName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="储存方式:" prop="storageMethodName">
                    <EllipsisWithTooltip :content="form.basicInfo.storageMethodName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否处方药品:" prop="isPrescription">
                    <EllipsisWithTooltip :content="form.basicInfo.isPrescription ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否高警示药品:" prop="isCautionDrug">
                     <EllipsisWithTooltip :content="form.basicInfo.isHighWarning ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否贵重药品:" prop="isValuableDrug">
                    <EllipsisWithTooltip :content="form.basicInfo.isValuable ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否川产:" prop="isSichuanProduction">
                    <EllipsisWithTooltip :content="form.basicInfo.isInSC ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否管控药品:" prop="isControl">
                    <EllipsisWithTooltip :content="form.basicInfo.isControl ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否需要试敏:" prop="isTestAllergy">
                    <EllipsisWithTooltip :content="form.basicInfo.isNeedSensitivity ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否新药:" prop="isNewDrug">
                     <EllipsisWithTooltip :content="form.basicInfo.isNewDrug ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否基药:" prop="isBasicDrug">
                    <EllipsisWithTooltip :content="form.basicInfo.isBasicMedicine ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="药品说明书:" prop="specification">
                    <EllipsisWithTooltip :content="form.basicInfo.instructions||'-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="药品附件图片:" prop="accessoriesImg">
                    <MyUpload
                      :canEdit="true"
                      :isLimitMaxSiz="true"
                      :oldList="form.basicInfo.accessoriesImg"
                      :defaultMaxSize="10"
                    ></MyUpload>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="药品性质" name="drugNature">
              <el-row :gutter="30" style="width: 100%;">
                <el-col :span="6">
                  <el-form-item
                    label="是否抗菌药品:"
                    prop="isAntibacterialDrug"
                  >
                    <EllipsisWithTooltip :content="form.nature.isAntibacterialDrug ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="抗菌级别:" prop="antibacterialLevel">
                    <EllipsisWithTooltip :content="form.nature.antibacterialLevelName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否抗生素药品:" prop="isAntisepsisDrug">
                    <EllipsisWithTooltip :content="form.nature.isAntibioticDrug ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="抗生素级别:" prop="antibioticLevel">
                    <EllipsisWithTooltip :content="form.nature.antibioticLevelName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="是否精神类药品:"
                    prop="isPsychotropicDrug"
                  >
                    <EllipsisWithTooltip :content="form.nature.isPsychotropicDrug ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="精神类级别:" prop="spiritualLevel">
                    <EllipsisWithTooltip :content="form.nature.spiritualLevelName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="是否放射性药品:"
                    prop="isRadioactiveDrug"
                  >
                    <EllipsisWithTooltip :content="form.nature.isRadioactiveDrug ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="放射性级别:" prop="radioactiveLevel">
                    <EllipsisWithTooltip :content="form.nature.radioactiveLevelName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否麻醉药品:" prop="isAnestheticDrug">
                    <EllipsisWithTooltip :content="form.nature.isAnestheticDrug ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否毒性药品:" prop="isToxicDrug">
                    <EllipsisWithTooltip :content="form.nature.isToxicDrug ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="是否激素药品:"
                    prop="isHormoneMedication"
                  >
                    <EllipsisWithTooltip :content="form.nature.isHormoneMedication ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="是否大输液药品:"
                    prop="isLargeInfusionDrugs"
                  >
                    <EllipsisWithTooltip :content="form.nature.isLargeInfusionDrugs ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否消化药品:" prop="isDigestiveDrugs">
                    <EllipsisWithTooltip :content="form.nature.isDigestiveDrugs ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否抗肿瘤药品:" prop="isAntitumorDrugs">
                    <EllipsisWithTooltip :content="form.nature.isAntitumorDrugs ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否心脑血管药品:" prop="isCVDrugs">
                    <EllipsisWithTooltip :content="form.nature.isCVDrugs ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否防疫药品:" prop="isEpDrugs">
                    <EllipsisWithTooltip :content="form.nature.isEpDrugs ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否营养药品:" prop="isNutritionalDrugs">
                    <EllipsisWithTooltip :content="form.nature.isNutritionalDrugs ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否制剂:" prop="isPreparation">
                    <EllipsisWithTooltip :content="form.nature.isPreparation ? '是' : '否'" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="控制信息" name="controlInfo">
              <el-row :gutter="30" style="width: 100%;">
                <el-col :span="6">
                  <el-form-item label="启禁状态:" prop="startStopStatus">
                    <EllipsisWithTooltip :content="form.nature.startStopStatus ?'启用':'禁用'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否收费:" prop="isCharge">
                    <EllipsisWithTooltip :content="form.nature.isCharge ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="近效期提前提醒（天）:" prop="erodByDay">
                    <EllipsisWithTooltip :content="form.nature.erodByDay ||'-' " />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="能否入柜:" prop="isInCabinet">
                     <EllipsisWithTooltip :content="form.nature.isInCabinet ? '是' : '否'" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="挂网信息" name="hangingNetInfo">
              <el-row :gutter="30" style="width: 100%;">
                <el-col :span="6">
                  <el-form-item label="是否挂网:" prop="isHanging">
                    <EllipsisWithTooltip :content="form.nature.isHanging ? '是' : '否'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="挂网类型:" prop="hangingTypeName">
                     <EllipsisWithTooltip :content="form.nature.hangingTypeName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="挂网药品类型:" prop="hangingDrugsType">
                     <EllipsisWithTooltip :content="form.nature.hangingDrugsTypeName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="挂网流水号:" prop="serialNumber">
                    <EllipsisWithTooltip :content="form.nature.serialNumber || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="挂网药品ID:" prop="onlineDrugID">
                    <EllipsisWithTooltip :content="form.nature.onlineDrugID || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="挂网单位:" prop="hangingUnits">
                    <EllipsisWithTooltip :content="form.nature.hangingUnits || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="挂网价:" prop="onlinePricing">
                    <EllipsisWithTooltip :content="form.nature.onlinePricing || '-'" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="医保信息" name="healthInsuranceInfo">
              <el-row :gutter="30" style="width: 100%;">
                <el-col :span="6">
                  <el-form-item label="国家医保编码:" prop="nalMedInsCode">
                    <EllipsisWithTooltip :content="form.nature.nalMedInsCode || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="国家医保名称:" prop="nalMedInsName">
                     <EllipsisWithTooltip :content="form.nature.nalMedInsName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="国家医保分类:" prop="nalMedInsClassName">
                     <EllipsisWithTooltip :content="form.nature.nalMedInsClassName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="医保报销等级:" prop="medInRebtLevelName">
                    <EllipsisWithTooltip :content="form.nature.medInRebtLevelName || '-'" />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="省医保编码:" prop="proMedInsCode">
                    <EllipsisWithTooltip :content="form.nature.proMedInsCode || '-'" />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="产品证件" name="licenseInfo" class="tab-table-box">
              <!-- <div class="registration-certificate-box">
                <span class="asterisk">*&nbsp;</span>
                <span>注册证:</span>
              </div> -->
              <RegistrationCertificate
                ref="registrationCertificate"
                :filterIds="ids"
                :defaultId="defaultId"
                :showOperate="false"
              />
            </el-tab-pane>
          </el-tabs>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel"
        >返回</el-button
      >
      <el-button class="btn default" v-preventReClick>操作记录</el-button>
      <el-button
        class="btn default"
        v-preventReClick
        @click="handleCopyAdd({ id: dataId })"
        >复制并新增</el-button
      >
      <el-button
        class="btn default"
        v-preventReClick
        @click="handleUpdate({ id: dataId })"
        >编辑</el-button
      >
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import { RejectProductUpdate, GetDetails } from "@/api";
import RegistrationCertificate from "./registration-certificate.vue";
import MyUpload from "@/components/my-upload";
import EllipsisWithTooltip from "./EllipsisWithTooltip.vue";

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: {
    RegistrationCertificate,
    MyUpload,
    EllipsisWithTooltip,
  },
  data() {
    return {
      reject: RejectProductUpdate,
      editPath: "drugInfoMaintain-edit",
      activeName: "basicInfo",
      form: {
        basicInfo: {
          code: "",
          name: "",
          commonName: "",
          pinyinCode: "",
          approvalNumber: "",
          specifications: "",
          dosageFormName: "",
          doseUnitName: "",
          basicdDose: "",
          drugTypeName: "",
          classification: "",
          classificationId: "",
          classificationName: "",
          financialClass: "",
          financialClassId: "",
          financialClassName: "",
          factoryInfoName: "",
          packagingMaterial: "",
          termOfValidityByMon: "",
          inventoryUnit: "",
          smallestUnit: "",
          inveUnitConverFactor: "",
          barcodeManagementName: "",
          retrospectCode: "",
          storageMethodName: "",
          isEthicals: "",
          isCautionDrug: "",
          isValuableDrug: "",
          isSichuanProduction: "",
          isControl: "",
          isTestAllergy: "",
          isNewDrug: "",
          isBasicDrug: "",
          specification: "",
          accessoriesImg: "",
        },
        nature: {
          isAntibacterialDrug: "",
          antibacterialLevel: "",
          isAntibioticDrug: "",
          antibioticLevel: "",
          isPsychotropicDrug: "",
          spiritualLevel: "",
          isRadioactiveDrug: "",
          radioactiveLevel: "",
          isAnestheticDrug: "",
          isToxicDrug: "",
          isHormoneMedication: "",
          isLargeInfusionDrugs: "",
          isDigestiveDrugs: "",
          isAntitumorDrugs: "",
          isCVDrugs: "",
          isEpDrugs: "",
          isNutritionalDrugs: "",
          isPreparation: "",
          startStopStatus: "",
          isCharge: "",
          erodByDay: "",
          isInCabinet: "",
          isHanging: "",
          hangingType: "",
          hangingDrugsType: "",
          serialNumber: "",
          onlineDrugID: "",
          hangingUnits: "",
          onlinePricing: "",
          nalMedInsCode: "",
          nalMedInsName: "",
          nalMedInsClass: "",
          medInRebtLevel: "",
          proMedInsCode: "",
        },
        certInfos: {},
      },
      ids: [],
      defaultId: "",
      dataId: "",
    };
  },
  props: {},
  created() {},
  methods: {
    cancel() {
      this.routePushWithParams(
        this.getMainPath(this.$route.path),
        this.$route.params
      );
    },
    // 获取数据
    async getFormData() {
      this.dataId = this.$route.query.id;
      const query = {
        MedicationInfoId: this.$route.query.id,
      };
      const res = await GetDetails(query);
      this.form = res.returnData;
      this.form.basicInfo.accessoriesImg =
        res.returnData.basicInfo.accessoriesImgData;
      if (this?.form?.certInfos.length <= 0) return;
      this.ids = this.form.certInfos.map((item) => item.productRegistCertId);
      this.defaultId = this.form.certInfos.find(
        (item) => item.isDefault === true
      )?.productRegistCertId;
      this.$nextTick(() => {
        this.$refs.registrationCertificate.getData();
      });
    },
    // filesChange (fileList) {
    //    this.form.basicInfo.accessoriesImg = JSON.stringify(fileList)
    // },
  },
  mounted() {
    this.getFormData();
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-form) {
  width: 100%;
}
:deep(.el-form-item) {
  display: flex;
  align-items: center;
}
.content {
  display: flex;
  flex-direction: column;
  width: 100%;
  .cont-main {
    overflow: hidden;
    height: 100%;
    display: block;
    .el-form {
      overflow: hidden;
      height: 100%;
      display: flex;
      flex-direction: column;
      .demo-tabs {
        margin-top: 10px;
        flex: 1;
        height: 0;
        padding-bottom: 8px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        :deep(.el-tabs__header) {
          border: 0;
          margin-bottom: 28px;
          .el-tabs__nav {
            width: 100%;
            border: 0;
            border-bottom: 1px solid #dddddd;
          }
          .el-tabs__item {
            margin-right: 5px;
            border: 1px solid #dddddd;
            border-bottom: 0;
            background: #f8fafc;
            border-radius: 5px 5px 0 0;
            &:first-child {
              margin-left: 20px;
            }
          }
          .is-active {
            border-bottom: 1px solid #fff;
            transform: translateY(1px);
            background: transparent;
          }
        }
        :deep(.el-tabs__content) {
          overflow-y: auto;
          .el-tab-pane {
            padding: 16px 24px;
            background: #f6fafd;
            display: flex;
            flex-wrap: wrap;
            .item-box {
              width: 25%;
              margin-bottom: 16px;
              .image-viewer-box {
                display: flex;
              }
            }
          }
          .tab-table-box{
            background: #fff;
             padding: 0 24px;
          }
          .certificate-box {
            background: #fff;
            padding: 0;
          }
          .el-form-item--default {
            margin-bottom: 24px;
          }
          :deep(.el-row) {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
.oldProduction {
  width: 100%;
  max-height: 120px;
  overflow-x: hidden;

  /deep/.el-select__tags {
    max-height: 120px !important;
  }
}
.registration-certificate-box {
   width: 100%;
  font-size: 14px;
  color: #606266;
  .asterisk {
    color: #ff5a5c;
    font-weight: bold;
  }
}
:deep(.el-form-item__content) {
  line-height: 30px;
  flex: 1;
  width: 0;
  display: flex;
  align-items: center;
}
:deep(.registration-certificate-content){
   margin-left: 0;
   margin-top: 0;
}
</style>
